export default __webpack_public_path__ + "static/media/esval.5cb55206.svg";